const chevronDown = (
  <path
    d="M0.625 0.875L4 4.25L7.375 0.875"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
export default chevronDown;
